import React from "react";
import { RydProject } from "../../model/project";
import {
    getRenderedWidthForHNC,
    normalizeClassName
} from "../../render/renderUtils";
import { CaretController } from "../../utils/ScrollController";
import { RydViewport } from "../widgets/RydViewport";
import { RydContextPlaneGrid } from "./RydContextGrid";
import { RydContextFramesLines } from "./RydContextFramesLines";
import { useSetWorkspaceContextPlane, useWorkspaceContextPlane } from "../../stores/WorkspaceStore";
import { ComputedContextFrame, ContextFrame, ContextPlane, TimeCut } from "../../model/context";


function enrichComputedContextFrames(
    projectLength: number,
    plane: ContextPlane
): {
    ccf: ComputedContextFrame,
    tc: ContextFrame,
    i: number
}[] {
    const r = plane.generateContextFrames(projectLength)
        .map((tc: ContextFrame, i) => {
            const computedContextFrame = tc.compute();
            return {
                ccf: computedContextFrame,
                tc,
                i
            };
        });
    return r;
}

export function RydContextPlane({
    project,
    caretController
}: {
    project: RydProject,
    caretController?: CaretController
}) {

    const contextPlane = useWorkspaceContextPlane();
    const setContextPlane = useSetWorkspaceContextPlane();

    const header = (<div className="piano-roll-header-info-bar">
        <div className={normalizeClassName(["piano-roll-header-controls", 'header-controls'])}>
            <button onClick={() => {
                contextPlane.stateObject.addRow();
                setContextPlane({ stateObject: contextPlane.stateObject });
            }}>Add row</button>
        </div>
    </div>
    );

    return (
        <RydViewport
            name="Chord Roll"
            hideTitle={true}
            adaptiveHeight={true}
            sticky={header}
            scrollController={caretController?.scrollController}
        >
            <div
                className="piano-roll-content-wrapper"
                style={{
                    width: getRenderedWidthForHNC({ notes: project.get(0), includeKeyboard: true })
                }} >

                <div className={normalizeClassName(['header-controls', 'global-header-controls', 'piano-roll-header-info-bar'])}
                    style={{
                        alignItems: 'baseline',
                        minHeight: '22px',
                        backgroundColor: 'color-mix(in srgb, var(--md-sys-color-surface-dim) 97%, white 3%)',
                        paddingLeft: 'var(--piano-roll-header-width)',
                        right: '0px',
                        position: 'relative',
                    }}>
                    {/* <ContainerLengthControl
                hnc={frame}
                redrawObserver={redrawObserver} /> */}
                    <RydContextPlaneGrid
                        project={project}
                        plane={contextPlane.stateObject}
                    />
                    <RydContextFramesLines
                        framesData={enrichComputedContextFrames(project.getLength(), contextPlane.stateObject)}
                    />
                </div>
            </div>
        </RydViewport>
    );
}
